<template>
    <div>
       <h1 class="is-size-3">Blood Mor</h1>  
       <nav class="level is-mobile">
						<div class="level-left">
                            <div class="level-item">
                                 <b-input v-model="searchBlMorTxt"  placeholder="type some blood mor. name"></b-input>
                            </div>
							<div class="level-item">
								<b-button
                                    v-if="blMorSelected.length>0"
                                    label="Clear selected"
                                    type="is-danger"
                                    icon-left="close"
                                    class="field"
                                    size="is-small"
                                    @click="blMorSelectedModel = []" />
							</div>
						</div>
						<div class="level-right">
							<div class="level-item">
								<!-- <button class="button is-warning">Button</button> -->
							</div>
						</div>
					</nav>



                <div  class="box"  v-if="blMorSelected.length>0">
                     <b-taglist>
                                    <b-tag 
                                        v-for="datSelected in blMorSelected"  :key="datSelected.id"
                                        size="is-medium"
                                        type="is-info is-light"
                                        close-type='is-danger'
                                        close-icon-type='is-dark'
                                        closable
                                        close-icon='delete'
                                        aria-close-label="Close tag"
                                        @close="deleteSelected(datSelected.id)">
                                        {{datSelected.name}}
                                    </b-tag>
                     </b-taglist>
                </div> 

 

       <b-table 
                            
                            :data="isEmpty ? [] : blMorFilter"
                            bordered 
                            striped 
                            hoverable 
                            mobile-cards 
                            paginated
                            :per-page="perPage"
                            :current-page.sync="currentPage" 
                            checkable 
                            :checked-rows.sync="blMorSelectedModel"
                            >


                                    <b-table-column  label="Bl.Mor"   v-slot="props">
                                        <text-highlight :queries="queries">  {{ props.row.name }} </text-highlight>
                                    </b-table-column>





                             <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                            </template>





       </b-table>



 
    </div>
</template>


<script>
import { mapMutations, mapState} from "vuex";


export default {
    name : "BlMor",
    computed:{
            ...mapState({
                blMor: state => state.manually_create_lab_automate.blMor ,
                blMorSelected: state => state.manually_create_lab_automate.blMorSelected ,
            }),
            blMorFilter(){
                const tmp = this.blMor.filter((dat)=>{
                
                    return dat.name.toUpperCase().indexOf(this.searchBlMorTxt.toUpperCase()) > -1 
                           
                })

       
                return tmp
            },
           queries(){
                return this.searchBlMorTxt.split(" ");
            } ,


            blMorSelectedModel : {
                get: function () {
                   return this.blMorSelected
                },
                set: function (newValue) {
                   this.setBlMorSelected(newValue)
                }
            },


    },
    methods:{
        ...mapMutations({
            setBlMorSelected : 'manually_create_lab_automate/setBlMorSelected' ,
        }),
     deleteSelected(_id){
        // console.log(payload)
        // assign into local
        const blMorSelectedLocal = this.blMorSelectedModel
        // assign into state


        const tmp = blMorSelectedLocal.find(dat=>dat.id == _id)
        if(tmp){
            const tmpIndex = blMorSelectedLocal.indexOf(tmp)
            blMorSelectedLocal.splice(tmpIndex,1)
            this.blMorSelectedModel = blMorSelectedLocal
        }
        
     }
    },
    data(){
        return{
            isEmpty : false,
            perPage : 10,
            currentPage : 1,
            // checkedRows : [],

            searchBlMorTxt : "",
        }
    }
}
</script>